import cn from "classnames";
import { PropsWithChildren } from "react";

import { LazyLoadAfterTrigger } from "@/src/component/partial/LazyLoadAfterTrigger";

interface SectionModuleElementProps {
  classes?: {
    className?: string;
    section?: string;
  };
  id?: string;
  tag?: "section" | "footer" | "div";
  style?: any;
  lazy?: "lazy" | "eager";
  considerLazy?: boolean;
  componentId?: string;
}

function ElementWithTag({ id, tag, style, children, classes }: PropsWithChildren<SectionModuleElementProps>) {
  //turn this off for now, need to tie this into A/B creation tool better
  const componentIdProps = {}; //; componentId ? { "component-id": componentId } : {};

  if (!classes?.className && !style) {
    return <>{children}</>;
  }
  const Tag = tag ?? "div";
  return (
    <Tag
      className={cn(classes?.section, classes?.className)}
      id={id}
      style={style}
      {...componentIdProps}
    >
      {children}
    </Tag>
  );
}

function SectionModuleElement({ id, tag, style, children, classes, lazy, considerLazy, componentId }: PropsWithChildren<SectionModuleElementProps>) {
  if (considerLazy) {
    if (lazy === "eager") {
      return (
        <ElementWithTag
          id={id}
          tag={tag}
          style={style}
          classes={classes}
          componentId={componentId}
        >
          {children}
        </ElementWithTag>
      );
    }
    return (
      <LazyLoadAfterTrigger
        lazy="lazy"
        triggers={["swiperSlideChange", "click", "touchstart", "scroll"]}
        autoTrigger={true}
        ComponentLazyLoad={<div />}
      >
        <ElementWithTag
          id={id}
          tag={tag}
          style={style}
          classes={classes}
          componentId={componentId}
        >
          {children}
        </ElementWithTag>
      </LazyLoadAfterTrigger>
    );
  }
  return (
    <ElementWithTag
      id={id}
      tag={tag}
      style={style}
      classes={classes}
      componentId={componentId}
    >
      {children}
    </ElementWithTag>
  );
}

export default SectionModuleElement;
